import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function ArtaCurriculum() {
  const curriculum = [{
    title: 'Vei afla ce este stresul și cum funcționează în corpul și mintea ta.',
    desc: 'Nu ca teorie medicală complicată, ci explicat simplu, pe înțelesul tău. Când înțelegi mecanismul, poți să îl gestionezi.'
  }, {
    title: 'Vei identifica tipurile de stres din viața ta.',
    desc: 'Nu tot stresul e la fel. Unele tipuri te consumă, altele te motivează. Aici înveți să le deosebești și să le gestionezi pe fiecare diferit.'
  }, {
    title: 'Vei învăța tehnici simple de respirație și relaxare pe care le poți folosi oricând.',
    desc: 'Nu exerciții complicate care cer o oră pe zi. Tehnici de câteva minute pe care le faci la birou, în mașină sau acasă și care îți calmează mintea instant.'
  }, {
    title: 'Vei învăța să îți calmezi mintea în momentele tensionate.',
    desc: 'Când simți că totul te copleșește, ai la dispoziție un set de instrumente pe care le folosești imediat. Nu mai reacționezi din panică, ci răspunzi din calm.'
  }, {
    title: 'Vei crea obiceiuri care îți susțin liniștea și energia zilnic.',
    desc: 'Nu doar tehnici de urgență, ci un mod de viață. Obiceiuri mici, simple, pe care le integrezi natural și care te susțin pe termen lung.'
  }, {
    title: 'Vei învăța să te eliberezi de stresul acumulat și să te bucuri de viață.',
    desc: 'Nu doar să supraviețuiești, ci să trăiești. Cu energie, cu claritate, cu bucurie. Și cu timp pentru tine.'
  }];
  return <section className="py-20 lg:py-32 bg-brand-cream relative" data-id="element-114">
      <div className="max-w-4xl mx-auto px-6" data-id="element-115">
        <SectionHeading title="Ce vei descoperi în acest curs" data-id="element-116" />

        <div className="space-y-5 mb-16" data-id="element-117">
          {curriculum.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="flex gap-4 items-start bg-white p-6 md:p-7 rounded-2xl shadow-sm border border-brand-text/5 hover:shadow-warm transition-shadow" data-id="element-118">
              <div className="flex-shrink-0 mt-1 w-10 h-10 rounded-full bg-brand-gold/10 flex items-center justify-center" data-id="element-119">
                <CheckCircle2 className="w-6 h-6 text-brand-gold" data-id="element-120" />
              </div>
              <div data-id="element-121">
                <h3 className="font-bold text-lg text-brand-text mb-2" data-id="element-122">
                  {item.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-123">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-124">
          <CTAButton data-id="element-125" />
        </motion.div>
      </div>
    </section>;
}